module.exports = __webpack_public_path__ + "static/media/25.b0ad9e65.mp3";